export const TRANSLATION_ID_MAPPING = {
  "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56": "Reader_DocumentID",
  "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4": "Reader_EmailAdress",
  "3B344AE3-080C-4DFF-B17F-177BCB8D6A15": "Reader_VerificationCode",
  "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8": "Reader_VerificationCode_Header",
  "F07FC5A9-C71D-4E63-911D-255E1544F3EB": "Reader_Authorize",
  "A4598B68-CC37-4B4D-9502-2A839C2C4865": "Reader_VerificationCode_Message",
  "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D": "Reader_ClickHere",
  "BF02D851-9481-4215-8EDD-2C4F1D1A14F5": "Reader_AuthorizeFailure",
  "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2": "Reader_GetVerificationCode",
  "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5": "Reader_VerificationCode_Instruction",
  "21E54828-A57B-4935-BBD5-40F08BD6F130": "Reader_VerificationCode_Remember",
  "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6": "Reader_PleaseGoBack",
  "998BBBEF-9B6E-437A-80DC-56621DCED16D": "Reader_Submit",
  "5C20C8C9-C580-43A4-9E18-577A1F4E431C": "Reader_ActualSize",
  "8BCEBAA5-21F8-4D04-89D4-5A76836CB327": "Reader_FitPage",
  "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD": "Reader_FullWidth",
  "BFE1787E-D04C-494C-A9E5-62496FA3FE08": "Reader_DistributionList",
  "AA313936-D9D9-408B-BBDB-6A8CE6CABB08": "Reader_SideNote",
  "7F73F129-096E-4BBA-B731-7A189872F835": "Reader_ReplyToOwner",
  "326A65C1-89D3-4554-ADAD-7B7E9B08E42C": "Reader_Print",
  "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F": "Reader_Zoom",
  "AE91A15B-35AF-480E-9250-8A65A062A596": "Reader_EnterYourEmailAddress",
  "B0C2990F-CDE0-45BE-B7DC-8C9B52338536": "Reader_Email",
  "6AB42951-6546-44B6-9750-C94B8BC3FA95": "Reader_Passcode",
  "442CE6A9-22AF-408A-A2AA-92EE577999A7": "Reader_OK",
  "B6785E69-9416-47A2-BDFA-9537E6A60591": "Reader_Getpasscode",
  "7754F0CA-053D-4203-9261-9A8D4BE56746": "Reader_GetPasscode",
  "818E8449-D5EE-4820-A646-9AC8D1D4F984": "Reader_EnterYourEmailAddressCode",
  "489cfa10-5fb7-43e9-a4dd-b97b3ea76188":
    "Reader_EnterYourEmailAddressCodeTextOption",
  "73D789E4-518B-41E5-AB1D-29FB252C960D": "Reader_EnterYourEmailAddressXerox",
  "DC458BAF-A9A8-403A-913A-A7C7C417A578": "Reader_Cancel",
  "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B": "Reader_DocumentExpired",
  "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C": "Reader_FailedVerifyCodeEmail",
  "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1": "Reader_Continue",
  "A43B773D-45DD-4968-809E-AE3271A639B3": "Reader_GeneralTermsFooter",
  "C920E4EB-129F-4EDC-BE19-B1CA133E0A19": "Reader_GeneralTerms",
  "674C0F1F-6EA4-443A-BD38-B47030C2ADA9": "Reader_Patent",
  "6F6B09DC-D705-4F70-A5AD-BA539115C23F": "Reader_CheckYourEmail",
  "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE": "Reader_APasscodeEmailed",
  "809D3F1D-D2E6-475D-BEAB-CE7A6795C147": "Reader_AVerificationCodeEmailed",
  "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4": "Reader_TryAgain",
  "AD9099E6-C2C1-480E-96F4-DC148642A783": "Reader_DocumentRestrictedAccess",
  "D22EFEBA-D89A-49E8-B544-DF728B2EC62C": "Reader_ReachedMaximumViews",
  "0FCF576E-DB5C-4246-B05F-E88215C69731": "Reader_DocumentIsNoLongerAvailable",
  "697A33A8-5735-4064-9866-E95832CC8303": "Reader_InactivityYourSessionWillEnd",
  "33903FCD-2591-469E-8891-E9B6F0746E3B": "Reader_Minutes",
  "12BCE010-F096-41B5-AE4F-EA98B2310538": "Reader_Seconds",
  "F84C536A-E172-4C14-B827-F06DC17E31D0": "Reader_SessionTimedOut",
  "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834": "Reader_YouHaveBeenInactive",
  "817258A6-5338-4508-8733-F6437E942CBD": "Reader_ContinueReadingDocument",
  "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7":
    "Reader_PrintingDocumentIsNotPermitted",
  "27FF1441-6850-4601-B2DD-075D3AD01AEE": "Reader_ConfirmYourVote",
  "771A386D-B1F0-485C-B448-1D340209D580": "Reader_OnlyVoteOnce",
  "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F": "Reader_Like",
  "CA3DB143-B23C-4351-B635-5E636C37664C": "Reader_Dislike",
  "E06FF01E-F57C-4337-94E5-986B31AB1D41": "Reader_Voting",
  "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987": "Reader_ProtectedDocumentAccess",
  "007CF6B5-9AED-4956-A5E8-2D27F40795F9": "Reader_ProtectedDocument",
  "EEC944B7-CF89-4073-AAB2-38C5CD4C388C": "Reader_AllRightsReserved",
  "53708ED8-B8C6-4246-AB81-76F49FAC7E1C": "Reader_Terms",
  "AB232AED-8FB4-4E72-A550-DC57477EA1BE": "Reader_DocumentServerUnavailable",
  "977B4401-07E3-4848-870E-D7519A89BE0A": "Reader_InternetConnectionRequired",
  "A46D6AA3-7989-468F-85FE-AA9CA637A63A": "Reader_EnteredEmailIsNotReadersList",
  "D4FE0525-1829-48FE-87F7-D248053B5BF8": "Reader_FailedSendVerifyCode",
  "A399DFA9-C65E-40CC-A51B-7D3825270DB6": "Reader_UserVerificationFailure",
  "01464BDE-1F06-4CE4-B382-0D12FD415573": "Reader_DocName",
  "0198A1C3-A616-4383-9CA1-2B686E7B2161": "Reader_ID",
  "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A": "Reader_EnterEmailGetPasscode",
  "4D24E110-C95C-44DC-8DE0-586EEFD43901": "Reader_PleaseEnterSubject",
  "55F7F90F-5079-44D9-80C6-75E5CA0F3D8E": "Reader_EmailSuccessfullySent",
  "2B5CD1B8-E2C1-40FE-8657-81297F664F97": "Reader_DigitalRightsManagement",
  "384088DF-3A77-4AE7-9B85-2349394EFC30": "Reader_ProtectedDocumentViewer",
  "BCE385E2-E768-479E-8A28-7D90B153347E": "Reader_ViewDistributionList",
  "549961D1-C11B-4EF6-BFFC-8DC5BB995463": "Reader_UsersList",
  "F4CE40B3-2391-4A0B-BBB9-930710845A68": "Reader_ViewSideNote",
  "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B": "Reader_NoteFrom",
  "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8": "Reader_ReplyToDocument",
  "3C7C0F84-FC5E-416A-9E6B-110606DBE2DF": "Reader_ClickToPrint",
  "BA8DC442-BB68-4D4F-978F-64DE3B71D467": "Reader_Send",
  "EF11C8AF-E646-493F-9016-583861FF6008": "Reader_Message",
  "C1988359-42CB-41A2-8336-C7767AAE9406": "Reader_Subject",
  "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256": "Reader_ToAddress",
  "39265EFF-9C1B-49D3-98BA-7110FA4AEB62": "Reader_YouWillLoggedIn",
  "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1": "Reader_ClickToVote",
  "3D2F2837-9063-40CB-AF53-5E7790373EA1": "Reader_DocumentHasNoAccess",
  "0F8665A9-F7F3-4D07-8F64-E0F0576079D0": "Reader_AccessDocument",
  "F99602CF-AF87-4DE1-A20B-E82A064F1B51": "Reader_SessionExpiredAccessDocument",
  "8B569962-71C7-48A6-BDD0-43C37B489D91": "Reader_PleaseTryAgain",
  "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9": "Reader_CheckYourConnection",
  "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3": "Reader_LegalNotices",
  "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7": "Reader_ClickServiceLevelTerms",
  "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B": "Reader_OtherService",
  "57061912-dd57-46f2-8f39-3b01a75b2fd6": "Reader_YourDocumentadressAcess",
  "67732020-983b-49d8-bc69-f27790bf009e": "Reader_ReadMore",
  "4ddea558-4a3f-43b8-bdb2-d69df1c2162c": "Reader_BotInfoMessage",
  "47dd41f8-d61f-42ad-a0be-38195c694d01": "Reader_robot",
  "4d9606ee-3ddd-46cb-8444-b656e4b217ad": "Reader_Botverified",
  "d46741cd-dc5d-4ba5-984f-2c4dec6989dd": "Reader_BotVerifiedMessage",
  "6B574532-AAD2-4356-86FC-5C2F27E90FFE": "Reader_InternetConnectProblem",
  "555ADB9D-8867-4455-8BB7-85EA9BA0C2BB": "Reader_ConnectivityReauthenticate",
  "a6bcc85d-c1b3-43c8-8424-4db0dc30ce18": "Reader_ClickGetPasscode",
  "ad4c892f-dd09-44e7-893a-09e59cfa22b5": "Reader_BlockMessage",
  "73243072-681e-41af-b4dc-bfe19afb7631": "Reader_AuthenticatingPleaseWait",
  "29d0e16e-63e2-4e15-999b-1d6843f5cc50": "Reader_RequestingPassCodePleaseWait",
  "30fcbad0-5163-4163-846a-6be2110781ce": "Reader_ReplyToDocumentPleaseWait",
  "9fee0ab5-c17f-4fc2-a5c2-b943069f442d": "Reader_PrintDocumentPleaseWait",
  "088dcf20-c3a7-489d-83c1-9a6b8030dc21": "Reader_NavigatingBnPagesPleaseWait",
  "fbe73c6d-d78c-48f7-aea0-686f67e636d4": "Reader_RequestAccess",
  "7c559ae0-d90c-4d3a-96c6-206e0d36fc93": "Email_RequestHasBeenSent",
  "6be3bcc2-0efb-4aa8-8c85-655e153f0c1d": "Email_PleaseWaitForApproval",
  "15b1a3a0-b5ee-4a65-989c-b9b156097f89": "Email_NoteOptional",
  "c66144a1-7979-45d1-8251-46a7c00534c5": "bothEmailAndMobileHeader",
  "a6268a79-a67f-4a1b-8087-05ba8f23ab6f": "whatsAppHeader",
  "3ecc943c-46cb-4046-8dee-940b7391be93": "smsAndWhatsAppHeader",
  "6691bc8e-b90d-446a-9009-067ccafeb427": "checkYourEmailMobile",
  "44f7c6c9-25d8-452c-b4be-5215c81bfa77": "passCodeSent",
  "f2f12378-a056-4138-96de-290021e9cbb8": "RPostReader_CheckYourEmail",
  "6986faf9-6af5-4ed1-b97a-df263ffe2a97": "RPosteader_GetPasscode",
  "2a97eee8-9319-4cd3-b0dc-b0279af1eee1":
    "Reader_RPostEnterYourEmailAddressCode",
  "1c0cca68-ba6b-4e1c-94cc-5a3bc7233469": "Reader_RPostEmail",
  "8dbdc4dd-a8c2-4237-8ea7-d333c9be398c": "RPostEmail_Passcode",
  "05549b08-3184-40f5-9743-59f07dbe6f92": "Reader_RPostAPasscodeEmailed",
  "e87b5485-cdb1-4ff7-abff-8a9e4a5535ec": "Reader_Optional",
  "d5444481-e72d-4f09-8f3c-99b6f09c22c1": "Reader_Note",
  "bdc284bb-3e64-408c-9649-5cc0dbe3557f": "Reader__validEmailMobile",
  "30ca726f-c2c9-4716-ba5b-b8a048999c2b": "Reader_ValidateMobileNumber",
  "c77447de-ae4a-42a9-9f82-f8bf21ed8d57": "Reader_LoadingPleaseWait",
  "c6216052-63c8-46f9-a4b2-e0fe9f7b90b7": "Reader_SendingYourPasscode",
  "8484f82d-fced-4afb-9151-92763d4249ca": "Reader_SendingYourRequest",
  "4c941478-d38c-4979-bff0-235a5f54cf47": "Reader_Agree",
  "d87e8d9a-b6c8-4ae1-be6e-7ba1ab774dfd": "Reader_Disagree",
  "bce8b84e-f5f3-4810-b655-269f66e3e9d4": "Reader_TermsofService",
  "3b3da676-f461-4404-8619-492e85a95de8": "Reader_Email_PasscodeOption2",
  "53e8f829-19a5-4b4d-963e-3db6e6789e34": "Reader_Email_PasscodeOption3",
  "349e29ea-8e3a-487e-91fc-ae97d7272e74": "passCodeSentViaText",
  "ff5ce10b-2864-4719-ad62-86f047722617":
    "emailOptionDisabledAndMobileOptionEnabled",
  "dcb769fa-24ca-4663-a72b-34f7f1e2eae3":
    "emailOptionEnabledAndMobileOptionDisabled",
  "7f5ca725-a931-4a19-9a39-582f9689559e": "reader_RequestAccess",
  "d06b0568-96aa-47f4-90d7-ef467c1e91ad": "firstNameRef",
  "51e99a8f-4a31-47b5-a2ff-f530f3b9b2a6": "lastNameRef",
  "72a0b41e-6866-4123-93a0-bd972ada81e8": "optionalText",
  "990178e2-744b-4961-8d11-537101ebe534": "requestAccessTextForEmailMobile",
  "ac4004a3-9eef-4a3a-ae1b-de59dd3213fa": "requestAccessTextForEmail",
  "57a4bb24-3a6c-4a5f-b6e0-e20aac05c1bc": "checkYourMobile",
  "5e854cbc-4664-48e7-9dc3-9c2be3786658": "readerMobileNumberPasscodeText",
  "33d700da-e8fe-4c9d-b271-21d1face2264": "Reader_RPDYouHaveBeenInactive",
  "7A4227D5-6EF9-4BB2-BB83-4D63FA9524D2": "Reader_NoUnitbalanceMessage",
  "dd95e45e-0fbd-4f34-aecf-021afcf57c3a": "Reader_SendingYourReply",
  "c440a0bc-3d9e-4cac-95a4-cddf1eec9a3a": "RPostReader_viewTime",
  "bc66c66e-43cf-42dc-bbf7-03166f4c6722": "Reader_YouDontHaveAccessToRequested",
  "99430065-7d6c-451b-ade7-bdccc645212d": "Reader_YouDontHaveAccess",
  "751eda8a-d7d1-4cb6-a70d-c0a24fcb2eaf": "Reader_AllowedPagesOnly",
  "CFC1376B-2F1F-4200-A0E8-19412FAB9474": "API_SubjectMsg",
  "3B15B3BF-8614-4F18-A536-945EBD9F3FDB": "Reader_EmailBodyMsg",
  "76c385b7-0cb7-4b34-80a1-8bc30add9fe1": "Reader_viewTime",
  "B4CC3606-EB28-4160-9D8B-CBB2CE6A0460": "Reader_minutesSmall",
  "6CF1E413-78A3-408D-A6AE-BE56762F8417": "Reader_secondsSmall",
  "752D062E-8E70-4E26-B3F5-59ADC21BAAB0": "Reader_YouWillbeLoggedOutIn",
  "B94853A4-C334-44F7-83BA-CC437BFE6BE5": "Reader_Close",
  "cb07e7e7-640e-498b-821a-733d50d51b1d": "Reader_AccessDenied",
  "56eaffa5-2cb2-4228-a8ff-348c18b36ea6": "Reader_AccessDeniedMsg",
  "EEF70668-0B37-4A72-9E60-00416F1B47E6": "Reader_DocumentLanuchDate",
  "984EE442-5659-46D2-BC7D-6E8B3C6720F6": "Reader_ReachedMaximumViewsperDocument",
  "105660ba-fb0f-4aa6-b4f1-365e0d63698e": "Reader_ScurityLevelChanged",
  "4ea2bad6-654f-4b75-bdf8-aae6c0e76beb": "Reader_PersonalInfoText",
  "52107006-d254-4747-9265-2ba221619a7c": "Reader_DocumentContentNotAvailable",
  "C98130F6-EF2C-4241-AB51-C09780A04385": "Reader_XeroxEmailSuccessfullySent",
  "45dc6e20-a9a2-4b1e-90b4-27dcae4809c3": "Reader_RpostDocumentHasNoAccess"
};
